if (!customElements.get('sa-hero-video')) {
  class SaHeroVideo extends HTMLElement {
    constructor() {
      super();
      this.syncBackground = this.syncBackground.bind(this);
    }

    connectedCallback() {
      this.enableAnimation = this.getAttribute('data-enable-animation') === 'true';

      // Desktop and mobile each render their own background video; only one is
      // visible at a time (the other slot is display:none per breakpoint).
      this.bgVideos = Array.prototype.slice.call(
        this.querySelectorAll('.sa-hero-video__bg-video')
      );
      this.content = this.querySelector('.sa-hero-video__content');

      this.syncBackground();
      // Re-sync when the breakpoint flips so the newly visible video plays and the
      // hidden one stops.
      this.mql = window.matchMedia('(max-width: 768px)');
      if (this.mql.addEventListener) this.mql.addEventListener('change', this.syncBackground);
      else if (this.mql.addListener) this.mql.addListener(this.syncBackground);

      this.initAnimation();
    }

    disconnectedCallback() {
      if (this.mql) {
        if (this.mql.removeEventListener) this.mql.removeEventListener('change', this.syncBackground);
        else if (this.mql.removeListener) this.mql.removeListener(this.syncBackground);
      }
    }

    // Plays the visible background video (muted autoplay) and pauses any hidden one.
    syncBackground() {
      if (!this.bgVideos || !this.bgVideos.length) return;
      this.bgVideos.forEach((video) => {
        // offsetParent is null when the element (or its slot) is display:none.
        const isVisible = video.offsetParent !== null;
        if (!isVisible) {
          video.pause();
          return;
        }
        video.muted = true;
        const attempt = () => {
          const p = video.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        };
        if (video.readyState >= 2) attempt();
        else video.addEventListener('canplay', attempt, { once: true });
      });
    }

    initAnimation() {
      if (!this.enableAnimation || !this.content || !('IntersectionObserver' in window)) return;

      this.content.classList.add('sa-hero-video__content--hidden');

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.content.classList.remove('sa-hero-video__content--hidden');
            this.content.classList.add('sa-hero-video__content--animate');
            obs.disconnect();
          });
        },
        { threshold: 0.2 }
      );

      observer.observe(this);
    }
  }

  customElements.define('sa-hero-video', SaHeroVideo);
}
